module.exports = __webpack_public_path__ + "assets/img/most_comment copy.6d197ed2.svg";